<template>
  <div v-show="prolist.length" class="history-list">
    <div class="history-list_title">
      <p>
        {{ $t('tianmu.myCreation') }}
      </p>
      <div v-if="!isEdit" class="history-list_control">
        <span @click="isEdit = true">{{ $t('base.modify') }}</span>
      </div>
      <div v-else class="history-list_control">
        <span class="red" @click="handlerDelete">{{ $t('base.delete') }}</span>
        <span @click="cancelDelete">{{ $t('base.cancel') }}</span>
      </div>
    </div>
    <ul class="history-list_container">
      <li
        v-for="(item, index) in prolist"
        :key="index"
        class="history-list_box"
        @click="!isEdit && handlerClick(item)"
      >
        <Card :item="item" :is-edit="isEdit" :is-history="true" />
        <!-- <el-checkbox v-if="isEdit" v-model="item.isChecked" class="checkbox" />
          <img v-if="item.src" :src="item.src">
          <div v-if="item.isLoading" class="history-list_loading">
            准备中
          </div> -->
      </li>
    </ul>
  </div>
</template>
<script>
import { alertsuccess, alerterror, warning, success } from '@assets/common';
import Card from './Card.vue';
import {
  FindSceneListByPage,
  Delete
} from '@/axios/IScene.js'


export default {
  components: {
    Card
  },
  props: {
    device: {
      type: Object,
      default: () => ({})
    },
    showEntry: {
      type: Number,
      default: 7
    }
  },
  data() {
    return {
      info: '',
      prolist: [],
      currentCreateImg: '',
      isCreateImgVisible: false,
      isCreateLoading: false,
      isEdit: false
    }
  },

  watch: {
  },
  mounted() {
    this.getHistory();
  },
  destroyed(){
  },
  methods: {
    refreshList() {
      this.getHistory();
    },
    async getHistory() {
      try {
        const res = await FindSceneListByPage({
          gpNo: this.device.Gpno,
          sceneName: '',
          pageIndex: 1,
          pageSize: 50,
          sortMode: 0,
          ShowEntry: this.showEntry,
          VDeviceId: this.device.VDeviceId
        });

        this.prolist = (res.Result.RecordList || []).map(item => ({
          img: item.IconUrl,
          name: item.SceneName,
          SceneId: item.SceneNo,
          SceneStatus: item.SceneStatus,
          isLoading: false,
          isChecked: false,
          status: 1 // 全部成功
        }));
      } catch (error) {

      }
      // const planId = await getPlanLibrary({
      //   vDeviceId: 1989598
      // });
      // debugger
      return
    },
    async handlerDelete() {
      const selectScenes = this.prolist.filter(item => item.isChecked);
      
      if (selectScenes.length === 0) {
        warning(this, this.$t('scene.selectScence'));
        return;
      }

      try {
        // 使用 Promise.all 并发删除
        await Promise.all(
          selectScenes.map(item => Delete({ sceneNo: item.SceneId }))
        )
        
        success(this, this.$t('notices.deleteSuccess'));
        this.isEdit = false;
        await this.getHistory();
      } catch (error) {
        alerterror( this.$t('sylogs.fail'));
      }
    },

    handlerClick(item) {
      if (this.isEdit) {
        item.isChecked = !item.isChecked;
        return;
      }
    },

    startEdit() {
      this.isEdit = !this.isEdit;
    },

    cancelDelete() {
      this.prolist.forEach(item => {
        item.isChecked = false;
      });
      this.isEdit = false;
    }
  },
}
</script>
<style lang="scss" scoped>
.history-list {
  padding: 20px 0;

  &_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 16px;
    
    span {
      color: #3F9EFE;
      cursor: pointer;
    }
  }

  &_loading {
    color: #fff;
  }


  &_container {
    display: flex;
    flex-wrap: wrap;

    li {
      position: relative;
      margin-right: 20px;
      margin-bottom: 20px;
    }
  }
}

.history-list_control {
  span {
    margin-right: 10px;

    &.red {
      color: red;
    }
  }
}
</style>
